export const Impuesto =
{
  Codigo: '01',
  CodigoTarifa: '08',
  Tarifa: 13,
  FactorIva: 0,
  Monto: 0,
  Exoneracion: null,
};
